export function getExtension(fileName?: string | null): string | null {
  if (!fileName) return null;
  const match = /\.([^.\s/\\]+)$/.exec(fileName.trim());
  return match ? match[1].toLowerCase() : null;
}
